<div class="row">
  <div class="col-12">
    <div class="alert alert-info alert-with-icon alert-dismissible fade show" data-notify="container">
      <button type="button" aria-hidden="true" class="close" data-dismiss="alert" aria-label="Close">
        <i class="nc-icon nc-simple-remove"></i>
      </button>
      <span data-notify="icon" class="nc-icon nc-bell-55"></span>
      <span data-notify="message">New Release updates were added - Version 0.0.1x</span>
    </div>  
  </div>
</div>

<div class="row">
  <div class="col-lg-3 col-md-6 col-sm-6">
    <div class="card card-stats">
      <div class="card-body ">
        <i *ngIf="isLoading" class="fa fa-spinner fa-pulse fa-fw"></i>
        <div *ngIf="!isLoading" class="row">
          <div class="col-5 col-md-4">
            <div class="icon-big text-center icon-warning">
              <i [ngClass]="emailSummary.displayIcon"></i>
            </div>
          </div>
          <div class="col-7 col-md-8">
            <div class="numbers">
                <p class="card-category">{{emailSummary.displayText}}</p>
                <p class="card-title">{{emailSummary.displayValue}}</p>  
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer ">
        <hr>
        <div class="stats" *ngIf="!isLoading">
          <i [ngClass]="emailSummary.displaySmallIcon"></i>
          <a [routerLink]="" (click)="onSummaryAction(emailSummary.actionName, emailSummary.actionMessage)">{{emailSummary.shortText}}</a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-6">
    <div class="card card-stats">
      <div class="card-body ">
        <div class="row">
          <div class="col-5 col-md-4">
            <div class="icon-big text-center icon-warning">
              <i class="nc-icon nc-chat-33 text-success"></i>
            </div>
          </div>
          <div class="col-7 col-md-8">
            <div class="numbers">
              <p class="card-category">Live Notifications</p>
              <p class="card-title">3500</p><p>
            </p></div>
          </div>
        </div>
      </div>
      <div class="card-footer ">
        <hr>
        <div class="stats">
          <i class="fa fa-calendar-o"></i>
          Last day
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-6">
    <div class="card card-stats">
      <div class="card-body ">
        <div class="row">
          <div class="col-5 col-md-4">
            <div class="icon-big text-center icon-warning">
              <i class="nc-icon nc-box-2 text-danger"></i>
            </div>
          </div>
          <div class="col-7 col-md-8">
            <div class="numbers">
              <p class="card-category">Documents Capacity</p>
              <p class="card-title">150GB</p><p>
            </p></div>
          </div>
        </div>
      </div>
      <div class="card-footer ">
        <hr>
        <div class="stats">
          <i class="fa fa-clock-o"></i>
          In the last hour
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-6">
    <div class="card card-stats">
      <div class="card-body ">
        <div class="row">
          <div class="col-5 col-md-4">
            <div class="icon-big text-center icon-warning">
              <i class="nc-icon nc-bullet-list-67 text-primary"></i>
            </div>
          </div>
          <div class="col-7 col-md-8">
            <div class="numbers">
              <p class="card-category">Reviews</p>
              <p class="card-title">+45K</p><p>
            </p></div>
          </div>
        </div>
      </div>
      <div class="card-footer ">
        <hr>
        <div class="stats">
          <i class="fa fa-refresh"></i>
          Update now
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="currentAction === 'showemaillogs'">
  <app-emailsLogs></app-emailsLogs>
</div>


